"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _customHeaderNames = require("./customHeaderNames");
Object.keys(_customHeaderNames).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _customHeaderNames[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _customHeaderNames[key];
    }
  });
});
var _httpCodeRanges = require("./httpCodeRanges");
Object.keys(_httpCodeRanges).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _httpCodeRanges[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _httpCodeRanges[key];
    }
  });
});
var _swrConfig = require("./swrConfig");
Object.keys(_swrConfig).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _swrConfig[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _swrConfig[key];
    }
  });
});
var _constantsGenerated = require("../constants-generated");
Object.keys(_constantsGenerated).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _constantsGenerated[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _constantsGenerated[key];
    }
  });
});
//# sourceMappingURL=index.js.map